import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './msalConfig';
import { NavLink } from "react-router-dom";
function SignInButton() {
  const { instance } = useMsal();

  const handleLogin = () => {    
    instance.loginPopup(loginRequest).catch((error) => {
      console.error(error);
    });
  };

  return (
  <NavLink className="fw-bold text-decoration-none" onClick={handleLogin}>
    ACCEDI COME UTENTE: ADMIN / TAS / GUEST
  </NavLink>  
  )
}

export default SignInButton;
